import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const usePreferencesStore = create(
  persist(
    (set) => ({
      wallColor: '#000000',
      wallThickness: 16,
      roomFillColor: '#ffffff',
      roomFillOpacity: 50, // Added default opacity
      
      // Default style for new objects (furniture, shapes)
      objectStrokeColor: null, // null means use item default
      objectFillColor: null,   // null means use item default
      
      setWallColor: (color) => set({ wallColor: color }),
      setWallThickness: (thickness) => set({ wallThickness: thickness }),
      setRoomFillColor: (color) => set({ roomFillColor: color }),
      setRoomFillOpacity: (opacity) => set({ roomFillOpacity: opacity }),
      
      setObjectStrokeColor: (color) => set({ objectStrokeColor: color }),
      setObjectFillColor: (color) => set({ objectFillColor: color }),
    }),
    {
      name: 'floorcraft-preferences',
    }
  )
);

export default usePreferencesStore;